import {
	type IMessage,
	type IMessageStatus,
	type IMessageType,
} from './message._._definitions'

export const mapMessagesFields = (messages: IMessage[]): IMessage[] => {
	return messages.map(mapMessageFields)
}

export const mapMessageFields = (message: IMessage): IMessage => {
	return {
		...message,
		...(message.status ? { status: message.status as IMessageStatus } : {}),
		...(message.type ? { type: message.type as IMessageType } : {}),
	} as IMessage
}

export const getMessageAuthor = (message: IMessage) => {
	return message.author
}

export const getMessageTemplate = (message: IMessage) => {
	return message.template
}

export const updateMessageContent = (
	message: IMessage,
	content: string,
): IMessage => {
	return {
		...message,
		content,
	}
}

export const sortMessagesByCreatedAt = (messages: IMessage[]): IMessage[] => {
	return messages.sort(
		(a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
	)
}

export const removeDuplicateMessages = (messages: IMessage[]): IMessage[] => {
	return Array.from(new Map(messages.map((m) => [m.id, m])).values())
}

export const sortMessagesByIndex = (
	messages: IMessage[],
	direction: 'asc' | 'desc' = 'desc',
): IMessage[] => {
	return messages.sort((a, b) => {
		const indexA = a.index ?? 0
		const indexB = b.index ?? 0
		return direction === 'asc' ? indexA - indexB : indexB - indexA
	})
}
